const Paths = {
    Home : "/",
    AboutUs : "/AboutUs",
    Product  : "/Product",
    Gallary : "/Gallary",
    ContactUs : "/ContactUs",
    ProductDetails : "/productdetails/:id",
    AllProduct : '/AllProduct'
} 

export default Paths